module.exports = __webpack_public_path__ + "static/media/zoom-in.45a97218.svg";